import {Component, ViewChild} from '@angular/core';
import {GetUserListingGQL} from "../../../../graphql/generated";
import {map} from "rxjs";
import {extractEdgesAndNodes} from "../../graphql/operators/extract-edges-and-nodes";
import {Table} from "primeng/table";

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.scss']
})
export class UsersListComponent {
  users: any

  dataLoaded: boolean = false
  loading: boolean = true
  @ViewChild('dt') table: Table;
  visible: boolean = false;

  constructor(
    private service: GetUserListingGQL
  ) {
    // this.ouvrages = service.fetch().pipe(
    //         map(result => result.data.getOuvrageListing),
    //         extractEdgesAndNodes(),
    //         tap(departments => this.store.departments$.next(departments)),
    //     );
  }

  ngOnInit() {
    this.loadUsers()
  }

  loadUsers() {
    this.service.watch().valueChanges.pipe(
      map(result => result.data.getUserListing),
      extractEdgesAndNodes()
    ).subscribe({
        next: value => {
          this.users = value
          this.dataLoaded = true
          this.loading = false
        },
        error: err => {
        }
      }
    )
  }

  clear(table: Table) {
    table.clear();
    // this.filter.nativeElement.value = '';
  }
}
